import i18next from "i18next";
import { NS_TELEHEALTH_CORE, telehealthCoreResoucesEn } from ".";
import {
  initI18nReact,
  LOCALE_EN,
  LOCALE_ES_US,
  LOCALE_PSEUDO,
} from "@growtherapy/i18n";
import { logger } from "../datadog/logger";
import { NS_SPROUT_CORE } from "@growtherapy/sprout-ui";
import { NS_SEEDLINGS_CORE } from "@grow-therapy-team/seedling-components";

export const CROWDIN_DISTRIBUTION_HASH = "e-55b8f1847490f0b920ba3b3mgk";

export const initI18n = (): void => {
  initI18nReact(i18next, {
    defaultNS: [NS_TELEHEALTH_CORE, NS_SPROUT_CORE, NS_SEEDLINGS_CORE],
    resources: telehealthCoreResoucesEn,
    otaOptions: {
      distributionHash: CROWDIN_DISTRIBUTION_HASH,
      localePath: "/locales",
      otaLanguages: [LOCALE_ES_US],
    },
    // Important for mixing bundled + backend-loaded languages
    partialBundledLanguages: true,
    // Supported languages
    load: "currentOnly",
    // Only load exact language codes, prevents 'es' fallback attempts
    supportedLngs: [LOCALE_EN, LOCALE_ES_US, LOCALE_PSEUDO],
    // Fallback behavior for missing values. empty stings are not valid translations
    returnEmptyString: false,
    // Disable Suspense so components render with EN fallback while async translations load
    react: { useSuspense: false },
    // Logger for missing keys on CSR
    saveMissing: true,
    saveMissingTo: "current",
    missingKeyHandler: (lngs, ns, key) => {
      logger.error(
        `[i18n] Missing translation key: ${key} ns: ${ns} lng: ${lngs} service: telehealth`,
      );
    },
  });
};
